import minimal from './minimal/theme';
import moonpetal from './moonpetal/theme';
import neonGrid from './neon-grid/theme';
import type { Theme } from './contract';
import { kebab, powerUpTileProperty } from './power-up-tokens';

export { DEFAULT_TOKENS, DEFAULT_ICONS, DEFAULT_POWER_UP_TILES, defineTheme } from './contract';
export type { Theme, IconName } from './contract';
export const DEFAULT_THEME = minimal;
/** Explicit shipped registry; only stable IDs are persisted. No remote code or user CSS. */
export const THEMES: readonly Theme[] = [minimal, moonpetal, neonGrid];

export function getTheme(id: string | null): Theme {
  return THEMES.find((theme) => theme.id === id) ?? DEFAULT_THEME;
}

export function applyTheme(theme: Theme, root: HTMLElement = document.documentElement): void {
  for (const [key, value] of Object.entries(theme.tokens)) {
    root.style.setProperty(`--theme-${kebab(key)}`, value);
  }
  for (const [kind, style] of Object.entries(theme.powerUps)) {
    for (const [property, value] of Object.entries(style))
      root.style.setProperty(powerUpTileProperty(kind, property), value);
  }
  root.setAttribute('data-theme', theme.id);
  root.style.colorScheme = theme.colorScheme;
  root.ownerDocument
    .querySelector('meta[name="theme-color"]')
    ?.setAttribute('content', theme.tokens.background);
  root.ownerDocument.querySelector('meta[name="color-scheme"]')?.setAttribute('content', theme.colorScheme);
}
